var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Popper from 'popper.js';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { addEvent } from '../util/dom';
import WithRender from './Popper.html';
export const DEFAULT_POPPER_TRIGGER_TYPE = 'click';
export const POPPER_TRIGGER_TYPE_HOVER = 'mouseover';
const ALLOWED_EVENTS = [DEFAULT_POPPER_TRIGGER_TYPE, POPPER_TRIGGER_TYPE_HOVER];
let VPopper = class VPopper extends Vue {
    constructor() {
        super(...arguments);
        this.showPopper = false;
    }
    get arrowClass() {
        return this.arrow ? 'has-arrow' : '';
    }
    get isVisible() {
        return this.showPopper;
    }
    mounted() {
        // TODO: Does it need safety check
        // Accessing slot element directly can cause it to break if slot is changed with `v-if`
        const anchor = this.anchor
            = (this.externalAnchor || this.$slots.anchor[0].elm);
        const content = this.content = this.$refs.content;
        const arrow = this.arrowElm = this.$refs.arrow;
        let modifiers = {
            arrow: {
                element: arrow,
                enabled: this.arrow
            }
        };
        if (this.preventParentOverflow) {
            modifiers['preventOverflow'] = {
                escapeWithReference: true
            };
        }
        this.popper = new Popper(this.anchor, content, {
            modifiers: modifiers
        });
        if (ALLOWED_EVENTS.includes(this.trigger)) {
            // TODO: Event cleanup
            addEvent(anchor, this.trigger, this.show);
            addEvent(document, this.trigger, this.hideOnDocumentClick);
        }
    }
    show() {
        this.showPopper = true;
        this.$nextTick()
            .then(() => this.popper.scheduleUpdate());
    }
    hide() {
        this.showPopper = false;
    }
    isTargetAnchor(target, anchor) {
        if (target === null) {
            return false;
        }
        if (target === anchor) {
            return true;
        }
        return this.isTargetAnchor(target.parentElement, anchor);
    }
    beforeDestroy() {
        this.popper.destroy();
    }
    hideOnDocumentClick(event) {
        if (this.isTargetAnchor(event.target, this.anchor) === false) {
            this.hide();
        }
    }
};
__decorate([
    Prop({ default: DEFAULT_POPPER_TRIGGER_TYPE }),
    __metadata("design:type", String)
], VPopper.prototype, "trigger", void 0);
__decorate([
    Prop(),
    __metadata("design:type", HTMLElement)
], VPopper.prototype, "externalAnchor", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], VPopper.prototype, "arrow", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], VPopper.prototype, "preventParentOverflow", void 0);
VPopper = __decorate([
    WithRender,
    Component({})
], VPopper);
export default VPopper;
//# sourceMappingURL=Popper.js.map